const POPUP_FEATURES = "width=800,height=650";
const POLL_INTERVAL_MS = 500;

/**
 * Opens an empty OAuth connect window. Call it synchronously from the click
 * handler, before awaiting anything: browsers only allow pop-ups that a user
 * gesture opens directly. Returns null when the browser blocks it.
 */
export function openConnectPopup(name: string): Window | null {
  return window.open("about:blank", name, POPUP_FEATURES);
}

/**
 * Resolves once the window closes. The OAuth pages are on another origin, so
 * polling `closed` is the only signal available.
 */
export function waitForPopupClose(
  popup: Window,
  intervalMs: number = POLL_INTERVAL_MS
): Promise<void> {
  return new Promise((resolve) => {
    const timer = window.setInterval(() => {
      if (!popup.closed) return;

      window.clearInterval(timer);
      resolve();
    }, intervalMs);
  });
}
